import { useMutation } from '@tanstack/react-query';
import {
  PostReviewBlockParams,
  PostReviewDeleteParams,
  PostReviewLikeParams,
  PostReviewReportParams,
} from '../types/review.type';
import { QUERY_KEYS } from '../base-api';
import {
  postReviewBlock,
  postReviewDelete,
  postReviewEdit,
  postReviewLike,
  postReviewReport,
  postReviewWrite,
} from '../review.service';

export const useReviewWrite = (academyId: string) => {
  return useMutation({
    mutationKey: [QUERY_KEYS.REVIEW, QUERY_KEYS.REVIEW_WRITE, academyId],
    mutationFn: ({
      academyId,
      formData,
    }: {
      academyId: string;
      formData: FormData;
    }) => {
      return postReviewWrite(academyId, formData);
    },
  });
};

export const useReviewEdit = (reviewId: number) => {
  return useMutation({
    mutationKey: [QUERY_KEYS.REVIEW, QUERY_KEYS.REVIEW_EDIT, reviewId],
    mutationFn: ({
      reviewId,
      formData,
    }: {
      reviewId: number;
      formData: FormData;
    }) => {
      return postReviewEdit(reviewId, formData);
    },
  });
};

export const useReviewDelete = (reviewId: number) => {
  return useMutation({
    mutationKey: [QUERY_KEYS.REVIEW, QUERY_KEYS.REVIEW_DELETE, reviewId],
    mutationFn: ({
      reviewId,
      params,
    }: {
      reviewId: number;
      params: PostReviewDeleteParams;
    }) => {
      return postReviewDelete(reviewId, params);
    },
  });
};

export const useReviewLike = (reviewId: number) => {
  return useMutation({
    mutationKey: [QUERY_KEYS.REVIEW, QUERY_KEYS.REVIEW_LIKE, reviewId],
    mutationFn: ({
      reviewId,
      params,
    }: {
      reviewId: number;
      params: PostReviewLikeParams;
    }) => {
      return postReviewLike(reviewId, params);
    },
  });
};

export const useReviewBlock = (reviewId: number) => {
  return useMutation({
    mutationKey: [QUERY_KEYS.REVIEW, QUERY_KEYS.REVIEW_BLOCK, reviewId],
    mutationFn: ({
      reviewId,
      params,
    }: {
      reviewId: number;
      params: PostReviewBlockParams;
    }) => {
      return postReviewBlock(reviewId, params);
    },
  });
};

export const useReviewReport = (reviewId: number) => {
  return useMutation({
    mutationKey: [QUERY_KEYS.REVIEW, QUERY_KEYS.REVIEW_REPORT, reviewId],
    mutationFn: ({
      reviewId,
      params,
    }: {
      reviewId: number;
      params: PostReviewReportParams;
    }) => {
      return postReviewReport(reviewId, params);
    },
  });
};
